import { Copy, Plus, X } from "lucide-react";
import { DAYS } from "@/lib/hours";

const timeCls = "bg-transparent border border-white/20 focus:border-white text-white h-10 px-2 outline-none [color-scheme:dark] w-[104px]";

const Slot = ({ slot, onChange, onRemove, testId }) => (
  <div className="flex items-center gap-2">
    <input type="time" value={slot[0]} onChange={(e) => onChange([e.target.value, slot[1]])} aria-label="Ouverture" data-testid={`${testId}-open`} className={timeCls} required />
    <span className="text-zinc-400">–</span>
    <input type="time" value={slot[1]} onChange={(e) => onChange([slot[0], e.target.value])} aria-label="Fermeture" data-testid={`${testId}-close`} className={timeCls} required />
    <button type="button" onClick={onRemove} aria-label="Retirer ce créneau" data-testid={`${testId}-remove`} className="w-8 h-10 text-zinc-400 hover:text-primary"><X className="w-4 h-4 mx-auto" /></button>
  </div>
);

// 7 days, up to 2 slots per day (lunch break); no slot = closed
export const HoursField = ({ value, onChange }) => {
  const hours = value || {};
  const setDay = (k, slots) => onChange({ ...hours, [k]: slots });
  const copyMonday = () => onChange(Object.fromEntries(DAYS.map(([k]) => [k, (hours.mon || []).map((s) => [...s])])));

  return (
    <div className="space-y-2" data-testid="place-form-hours">
      {DAYS.map(([k, label]) => {
        const slots = hours[k] || [];
        return (
          <div key={k} className="flex flex-wrap items-center gap-x-4 gap-y-2 py-2 border-b border-white/10" data-testid={`hours-day-${k}`}>
            <span className="w-24 text-sm font-bold text-white">{label}</span>
            {slots.length === 0 && <span className="text-sm text-zinc-400">Fermé</span>}
            {slots.map((s, i) => (
              <Slot key={i} slot={s} testId={`hours-${k}-${i}`} onChange={(v) => setDay(k, slots.map((x, j) => (j === i ? v : x)))}
                onRemove={() => setDay(k, slots.filter((_, j) => j !== i))} />
            ))}
            {slots.length < 2 && (
              <button type="button" onClick={() => setDay(k, [...slots, slots.length ? ["14:00", "19:00"] : ["10:00", "19:00"]])} data-testid={`hours-${k}-add`}
                className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.15em] font-bold text-primary hover:text-white">
                <Plus className="w-3.5 h-3.5" /> {slots.length ? "Après une pause" : "Ouvert"}
              </button>
            )}
          </div>
        );
      })}
      <button type="button" onClick={copyMonday} disabled={!hours.mon?.length} data-testid="hours-copy-monday"
        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] font-bold text-zinc-300 hover:text-white disabled:opacity-40 mt-2">
        <Copy className="w-3.5 h-3.5" /> Copier les horaires du lundi sur toute la semaine
      </button>
      <p className="text-xs text-zinc-400">Après minuit (ex. 18h – 2h) : mets simplement 02:00 en fermeture.</p>
    </div>
  );
};
